import { ApiClient } from '../../core/http/api_client';
import { ItemImprovementMessageEnv } from '../models/item_information_error_report/item_improvement_message_env';
import { Env } from '../../core/env';

export class ItemInformationErrorReportRepository {

  static callCreateItemImprovementMessage = (
    itemImprovementMessage: string,
    largeClassType: string,
    smallClassType: string,
    supplierId: string,
    catalogItemCode: string,
    itemGroupCode: string,
    fromScreenType: string
  ) => {
    const parameter
      = new ItemImprovementMessageEnv(
        itemImprovementMessage,
        largeClassType,
        smallClassType,
        supplierId,
        catalogItemCode,
        itemGroupCode,
        fromScreenType
      );

    ApiClient.post(Env.SETTING.userPublicApi.urlBase + 'api/attract/item/itemImprovementMessage', parameter);
  }

}
